import { DeliveryModelEnum, MarketplaceBillingEnum } from "../routes/app/routes/tenants/api/Representation";
export function userCanAccessAllTenants(user) {
    return (user?.canAccessAllTenants && !userBelongsToATenant(user)) ?? false;
}
export function userBelongsToATenant(user) {
    return (user && user.tenants && user.tenants.length > 0) ?? false;
}
export function isUserDivisional(user) {
    return userHasRole(user, "DIVISIONAL");
}
export function resolveUserOrSelectedTenant(loggedInUser, selectedTenant) {
    if (selectedTenant && selectedTenant.id) {
        return selectedTenant;
    }
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length === 1) {
        return loggedInUser.tenants[0];
    }
    return null; // Multi tenant user with no selected tenant
}
export function userHasContractTenancy(loggedInUser, selectedTenant) {
    if (selectedTenant && selectedTenant.id) {
        return selectedTenant.canContract;
    }
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length) {
        return loggedInUser.tenants.filter(t => 'canContract' in t && t.canContract).length > 0;
    }
    return false;
}
export function getLoggedInUsersDefaultTimezoneName(loggedInUser) {
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length && 'timezone' in loggedInUser.tenants[0]) {
        return loggedInUser.tenants[0].timezone.name;
    }
    return "";
}
export function isInLoggedInUsersTenancy(loggedInUser, selectedTenantId, checkTenantId) {
    if (selectedTenantId) {
        // noinspection EqualityComparisonWithCoercionJS
        return checkTenantId == selectedTenantId;
    }
    else if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length) {
        // noinspection EqualityComparisonWithCoercionJS
        return loggedInUser.tenants.filter(tenant => tenant.id == checkTenantId).length > 0;
    }
    return false;
}
function userBelongsToMultiTenants(user) {
    return (user && user.tenants && user.tenants.length > 1) ?? false;
}
export function isUserMultiTenant(user) {
    return userCanAccessAllTenants(user) || userBelongsToMultiTenants(user);
}
export function userHasRole(user, roleName) {
    let hasRole = false;
    if (user) {
        hasRole = user.roles && user.roles.filter(r => r === roleName).length > 0;
    }
    return hasRole;
}
export function userHasPermission(user, permissions) {
    if (user && user.permissions && permissions) {
        const userPermissions = user.permissions;
        return userPermissions.filter(Set.prototype.has, new Set(permissions)).length > 0;
    }
    return false;
}
export function getDivisionName(loggedInUser, selectedTenant) {
    if (selectedTenant && selectedTenant.id && selectedTenant.divisionName) {
        return selectedTenant.divisionName;
    }
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length && 'divisionName' in loggedInUser.tenants[0]) {
        return loggedInUser.tenants[0].divisionName;
    }
    return "Division";
}
export function shouldShowDivision(loggedInUser, selectedTenant) {
    if (selectedTenant && selectedTenant.id) {
        return selectedTenant.usesDivisions;
    }
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length && 'usesDivisions' in loggedInUser.tenants[0]) {
        return loggedInUser.tenants[0].usesDivisions;
    }
    return false; // SubTrux admin must have a tenant selected to divisions column
}
export function isUserDeliveryModelTransferToDc(loggedInUser, selectedTenant) {
    if (selectedTenant && selectedTenant.id) {
        return selectedTenant.defaultDeliveryModel === DeliveryModelEnum.TRANSFER_TO_DC;
    }
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length) {
        return loggedInUser.tenants.filter(t => 'defaultDeliveryModel' in t && t.defaultDeliveryModel === DeliveryModelEnum.TRANSFER_TO_DC).length > 0;
    }
    return false;
}
export function isUserMarketplacePayAsYouGo(loggedInUser, selectedTenant) {
    if (selectedTenant && selectedTenant.id) {
        return selectedTenant.marketplaceBillingType === MarketplaceBillingEnum.PAY_AS_YOU_GO;
    }
    if (loggedInUser && loggedInUser.tenants && loggedInUser.tenants.length) {
        return loggedInUser.tenants.filter(t => 'marketplaceBillingType' in t && t.marketplaceBillingType === MarketplaceBillingEnum.PAY_AS_YOU_GO).length > 0;
    }
    return false;
}
export function userPermissionFilter(user, obj) {
    if (obj.permissions && obj.permissions.length > 0) {
        return userHasPermission(user, obj.permissions);
    }
    return true;
}
